<template>
  <div class="demonstration-sheet-wrapper">
    <div class="demonstration-sheet-backdrop"></div>

    <section class="demonstration-sheet">
      <div class="sheet-content">
        <h3 class="demonstration-title">
          {{ $t('home.demonstration.title') }}
        </h3>
        <p class="demonstration-text">
          <span class="highlight">{{ $t('home.demonstration.text_1') }}</span>
          <span>{{ $t('home.demonstration.text_2') }}</span>
        </p>

        <div class="machine-viewport">
          <div class="machine-container">
            <div class="merchandising">
              <img
                class="qr-code-machine"
                src="@/assets/images/qr_code.png"
                alt="qrcode"
              >
              <img
                class="logo-machine"
                src="@/assets/images/logo.png"
                alt="logo"
              >
            </div>
            <div class="container-slots">
              <div
                v-for="slot in totalSlots"
                :key="slot"
                class="slot"
                :class="{ 'slot-selected': isSelected(slot) }"
              >
                <img
                  v-if="isSelected(slot)"
                  class="selected-hand"
                  src="@/assets/images/hand_take_battery_2.gif"
                  alt="hand"
                >
                <img
                  v-else
                  src="@/assets/images/slot.png"
                  class="img-slot"
                  alt="slot"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'TakeDemonstration',
    props: {
      totalSlots: {
        type: Number,
        default: 9
      },
      selectedSlot: {
        type: Number,
        default: 7
      }
    },
    emits: [],
    methods: {
      isSelected(slot) {
        return slot == this.selectedSlot
      }
    }
  }
</script>

<style scoped lang="scss">
  @use 'sass:color';
  @use '@/main.scss' as main;

  .demonstration-sheet-wrapper {
    position: fixed;
    inset: 0;
    z-index: 10000;
  }

  .demonstration-sheet-backdrop {
    position: absolute;
    inset: 0;
    background: rgb(0 0 0 / 35%);
  }

  .demonstration-sheet {
    position: absolute;
    left: 0;
    right: 0;
    bottom: var(--app-fixed-bottom-offset, 0px);
    background: #fff;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -4px 20px rgb(0 0 0 / 15%);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .sheet-content {
    padding: 16px;
    padding-top: 20px;
    text-align: center;
  }

  .demonstration-title {
    font-size: 1rem;
    font-weight: 700;
    color: #2f3944;
    margin-bottom: 8px;
  }

  .demonstration-text {
    font-size: 0.85rem;
    color: #5d6d7e;
    line-height: 1.4;
    margin-bottom: 12px;

    .highlight {
      font-weight: 700;
      color: main.$color-energy-blue;
    }
  }

  .machine-viewport {
    display: flex;
    justify-content: center;
    padding: 10px 0;
  }

  .machine-container {
    background-color: #1a1a1a;
    border-radius: 12px;
    padding: 16px;
    width: 100%;
    max-width: 280px;
    box-shadow:
      inset 0 2px 10px rgba(255, 255, 255, 0.1),
      0 10px 20px rgba(0, 0, 0, 0.4);
    position: relative;
    border: 1px solid #333;
  }

  .merchandising {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 6px;
  }

  .qr-code-machine {
    width: 20%;
    height: auto;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.2));
  }

  .logo-machine {
    width: 65%;
    height: auto;
  }

  .container-slots {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 8px;
    background: #000;
    border-radius: 8px;
  }

  .slot {
    width: 100%;
    aspect-ratio: 1;
    position: relative;
    background: #222;
    border-radius: 4px;
    overflow: visible;
  }

  .img-slot {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }

  .selected-hand {
    width: 390%;
    position: absolute;
    top: -427%;
    left: -147%;
    z-index: 20;
    pointer-events: none;
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    .sheet-content {
      padding: 12px;
      padding-top: 16px;
    }

    .machine-container {
      padding: 12px;
    }

    .container-slots {
      gap: 6px;
    }
  }
</style>
